import { render } from "./category_attributes.vue?vue&type=template&id=37bab25e"
import script from "./category_attributes.vue?vue&type=script&lang=js"
export * from "./category_attributes.vue?vue&type=script&lang=js"

import "./category_attributes.vue?vue&type=style&index=0&id=37bab25e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__